// extracted by mini-css-extract-plugin
module.exports = {"wave2DetailP":"P_wave2DetailP__Zg1nj"};